import { FontAwesomeIcon } from '@hivebrite/design-system/FontAwesomeIcon';

const CircleExclamation = () => (
  <FontAwesomeIcon height="16px" iconName="circle-exclamation" />
);
const Delete = () => <FontAwesomeIcon height="16px" iconName="trash-can" />;
const Edit = () => <FontAwesomeIcon height="16px" iconName="pen" />;

export const actionItemsIcons = {
  circleExclamation: CircleExclamation,
  delete: Delete,
  edit: Edit,
};
